import { PropsWithChildren } from 'react'
import { CollapseContainer, CollapseBody, CollapseContent } from './styles'

interface CollapseProps {
  isOpen: boolean
  collapseHeader: React.ReactElement
}

function Collapse({
  children,
  isOpen,
  collapseHeader,
}: PropsWithChildren<CollapseProps>) {
  return (
    <CollapseContainer>
      {collapseHeader}
      <CollapseBody open={isOpen}>
        <CollapseContent>{children}</CollapseContent>
      </CollapseBody>
    </CollapseContainer>
  )
}

export default Collapse
